import AutoLinkText from 'react-autolink-text2';

const AutomaticLinkText = ({ text }) => (
  <div onClick={(e) => e.stopPropagation()}>
    <AutoLinkText text={text} linkProps={{ target: '_blank', style: { color: '#1a4983' } }} />
  </div>
);

export default AutomaticLinkText;
